/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PriorityVideoItem { 
    video_id: string;
    title: string;
    status: string;
    competition_id?: number | null;
    competition_name?: string | null;
    is_manual_priority?: boolean;
    is_competition_priority?: boolean;
    effective_priority: number;
    priority_source: string;
}

